function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { themify, boxShadow } from '../styles/mixins';
import { curves } from '../styles/theme';
import { animated } from '../lib/hoc/withAnimation';
import { withSpacing } from '../lib/hoc/withSpacing';
export const StyledCard = styled.div.withConfig({
  displayName: "Card__StyledCard",
  componentId: "mzki55-0"
})(["position:relative;background:", ";font-size:", ";border:", ";color:", ";border-radius:", ";transition:background 0.2s ", ",border 0.2s ", ",color 0.2s ", ",box-shadow 0.2s ", ";", ";", ";a &{cursor:pointer;}", ""], x => x.$bgColor, x => x.theme.type.scale[x.$fontSize], x => x.$borderColor ? `1px solid ${x.$borderColor}` : 'none', x => x.$color, x => x.$borderRadius, curves.standard, curves.standard, curves.standard, curves.standard, x => x.$zIndex && css(["z-index:", ";"], x => x.$zIndex), x => boxShadow(x.$shadow), x => x.$hoverShadow && css(["&:hover{", ";}"], x => boxShadow(x.$hoverShadow)));

const CardFunc = (_ref) => {
  let {
    bgColor = 'white',
    borderColor,
    borderRadius = '6px',
    children,
    color,
    fontSize = 5,
    hoverShadow,
    shadow = 'sm',
    zIndex
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["bgColor", "borderColor", "borderRadius", "children", "color", "fontSize", "hoverShadow", "shadow", "zIndex"]);

  return /*#__PURE__*/React.createElement(StyledCard, _extends({
    $bgColor: themify(bgColor),
    $borderColor: themify(borderColor),
    $borderRadius: borderRadius,
    $color: themify(color),
    $fontSize: fontSize,
    $hoverShadow: hoverShadow,
    $shadow: shadow,
    $zIndex: zIndex
  }, rest), children);
};

export const Card = animated(withSpacing(CardFunc, {
  p: 2
}), {
  animation: 'floatIn'
});